module.exports = __webpack_public_path__ + "img/projects.2ad40098.png";